import { useContext } from 'react';

// eslint-disable-next-line no-restricted-imports -- deprecated - use RouteState instead
import { RoutesContext } from '@confluence/route-manager/entry-points/RoutesContext.ts';

import { View } from './homeRouteParams.ts';

export const useSelectedView: () => View = () => {
	const { match } = useContext(RoutesContext);
	const view = match?.params?.view as View;
	return Object.values(View).includes(view) ? view : View.OVERVIEW;
};
